import React, { useCallback, useEffect, memo } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import * as yup from 'yup'

import TextInput from 'components/CommonUI/TextInput/TextInput'
import Button from 'components/CommonUI/Button/Button'
import {
  loginUser,
  getNewPasswordRequiredDataSelector,
} from 'redux/reducers/profile'
import { useShallowEqualSelector } from 'custom-hooks'

let loginSchema = yup.object().shape({
  login: yup.string().email().required(),
  password: yup.string().required(),
})

const LoginForm = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const newPasswordRequired = useShallowEqualSelector(
    getNewPasswordRequiredDataSelector
  )

  const formik = useFormik({
    initialValues: {
      login: '',
      password: '',
    },
    onSubmit: (values) => dispatch(loginUser(values)),
    validationSchema: loginSchema,
    validateOnBlur: true,
    validateOnChange: false,
  })

  const handleClickForginPassword = useCallback(() => {
    history.push('/auth/recovery-password')
  }, [history])

  useEffect(() => {
    if (!formik.values.login && formik.touched.login) {
      formik.setFieldTouched('login', false)
    }
    if (!formik.values.password && formik.touched.password) {
      formik.setFieldTouched('password', false)
    }
  }, [formik])

  useEffect(() => {
    if (newPasswordRequired && newPasswordRequired.email) {
      history.push('/auth/confirm-restore-password', {
        confirmCode: 'new_password',
        userName: newPasswordRequired.email,
      })
    }
  }, [history, newPasswordRequired])

  return (
    <>
      {/* <Title content="Nice to meet you!" /> */}
      <form onSubmit={formik.handleSubmit}>
        <TextInput
          placeholder="email@mail.com"
          styleType="dark"
          classNameContainer="auth_login_form_input"
          mb={35}
          value={formik.values.login}
          onChange={formik.handleChange}
          name="login"
          errorMessage={
            (!!formik.values.login &&
              formik.touched.login &&
              formik.errors.login) ||
            (formik.submitCount && formik.errors.login)
          }
          onBlur={formik.handleBlur}
        />
        <TextInput
          placeholder="password"
          styleType="dark"
          classNameContainer="auth_login_forml_input"
          mb={35}
          type="password"
          value={formik.values.password}
          onChange={formik.handleChange}
          name="password"
          errorMessage={
            (!!formik.values.password &&
              formik.touched.password &&
              formik.errors.password) ||
            (formik.submitCount && formik.errors.password)
          }
          onBlur={formik.handleBlur}
        />
        <Button className="auth_login_forml_button" mb={16} type="submit">
          Login
        </Button>
      </form>
      <Button variant="text" fs={16} onClick={handleClickForginPassword}>
        Forgot password?
      </Button>
    </>
  )
}

export default memo(LoginForm)
